import React from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { nhlTeamColors } from "../PlayerCard/Constants";
import ConsensusComparisonBadge from "../ConsensusComparisonBadge/ConsensusComparisonBadge";
import "./MediaRankingPlayers.css";

const DEFAULT_PLAYER_IMAGE =
    "https://awoiaf.westeros.org/images/thumb/5/56/No_portrait.svg/240px-No_portrait.svg.png";

/**
 * @param {object} props
 * @param {object} props.player
 * @param {number|string} props.rank
 * @param {"Rank"|"Pick"} [props.rankLabel]
 * @param {object} [props.team] - mock draft team
 * @param {{ consensusRank: number, delta: number }|null} [props.consensusComparison]
 */
function MediaRankingListRow({
    player,
    rank,
    rankLabel = "Rank",
    team,
    consensusComparison,
}) {
    const flagUrl = player.country?.flag_url || player.flag_url;
    const dobFormatted = player.dob
        ? format(new Date(player.dob), "MMM d, yyyy")
        : null;

    return (
        <Link to={`../player/${player.player_id}`} className="media-ranking-list-row">
            <span className="media-ranking-list-rank" aria-label={`${rankLabel} ${rank}`}>
                <span className="media-ranking-list-rank-label">{rankLabel}</span>
                <span className="media-ranking-list-rank-value">{rank}</span>
            </span>
            <img
                className="media-ranking-list-thumb"
                src={player.player_image_url || DEFAULT_PLAYER_IMAGE}
                alt=""
                loading="lazy"
            />
            <div className="media-ranking-list-info">
                <span className="media-ranking-list-name">
                    {player.first_name} {player.last_name}
                </span>
                <span className="media-ranking-list-meta">
                    {player.position && <span>Pos: {player.position}</span>}
                    {dobFormatted && <span>DOB: {dobFormatted}</span>}
                </span>
            </div>
            {consensusComparison !== undefined && (
                <div className="media-ranking-list-consensus">
                    <ConsensusComparisonBadge
                        comparison={consensusComparison}
                        variant="list"
                    />
                </div>
            )}
            {flagUrl && (
                <img className="media-ranking-list-flag" src={flagUrl} alt="" loading="lazy" />
            )}
            {team && (
                <span
                    className="media-ranking-list-team"
                    style={{
                        backgroundColor: nhlTeamColors[team.team_id] || "var(--bg-surface-2)",
                    }}
                >
                    {team.team_name}
                </span>
            )}
        </Link>
    );
}

export default MediaRankingListRow;
